export const commentFiltersToString = (filtersObject) => {
  const {driverId, teamId, bookmark, sentiment, cycleId} = filtersObject
  const filter = [`cycle:id:${cycleId}`]
  if (driverId) filter.push(`driver:id:${driverId}`)
  if (teamId) filter.push(`team:id:${teamId}`)
  if (bookmark) filter.push(`bookmark:note:${bookmark}`)
  if (sentiment) filter.push(`sentiment:sentiment:${sentiment}`)
  return filter.join(",")
}
